module.exports = __webpack_public_path__ + "static/media/EWT.a90ad10f.svg";